import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";
import { Typography } from "@/components/ui/typography";
import {
  formatNumber,
  formatNumberInput,
  parseFormattedNumber,
} from "@/utils/format/formatNumber";
import { useState } from "react";

interface PriceRangeProps {
  fromValue: string;
  toValue: string;
  onFromChange: (value: string) => void;
  onToChange: (value: string) => void;
}

export const PriceRange: React.FC<PriceRangeProps> = ({
  fromValue,
  toValue,
  onFromChange,
  onToChange,
}) => {
  const [sliderValues, setSliderValues] = useState<number[]>([0, 50000000]);

  const handleSliderChange = (values: number[]) => {
    setSliderValues(values);
    onFromChange(values[0].toString());
    onToChange(values[1].toString());
  };

  const handleFromInputChange = (value: string) => {
    const raw = parseFormattedNumber(value);
    onFromChange(raw);
    setSliderValues([raw === "" ? 0 : Number(raw), sliderValues[1]]);
  };

  const handleToInputChange = (value: string) => {
    const raw = parseFormattedNumber(value);
    onToChange(raw);
    setSliderValues([sliderValues[0], raw === "" ? 50000000 : Number(raw)]);
  };

  return (
    <div className="space-y-3 p-2 md:p-4">
      <div className="flex items-center gap-4 md:gap-5 mb-6">
        <div className="relative flex-1">
          <Label
            className="text-[10px] font-medium text-gray-500 absolute z-10 -top-2.5 right-2 bg-background p-1"
            htmlFor="from"
          >
            از
          </Label>
          <Input
            id="from"
            type="text"
            inputMode="numeric"
            placeholder="۰ تومان"
            className="rounded-xl border-gray-200 h-10 placeholder:text-gray-400 font-normal !text-xs"
            value={formatNumberInput(fromValue)}
            onChange={(e) => handleFromInputChange(e.target.value)}
          />
        </div>
        <div className="relative flex-1">
          <Label
            className="text-[10px] font-medium text-gray-500 absolute z-10 -top-2.5 right-2 bg-background p-1"
            htmlFor="to"
          >
            تا
          </Label>
          <Input
            id="to"
            type="text"
            inputMode="numeric"
            placeholder="۵۰٬۰۰۰٬۰۰۰ تومان"
            className="rounded-xl border-gray-200 h-10 placeholder:text-gray-400 font-normal !text-xs"
            value={formatNumberInput(toValue)}
            onChange={(e) => handleToInputChange(e.target.value)}
          />
        </div>
      </div>

      <Slider
        value={sliderValues}
        onValueChange={handleSliderChange}
        min={0}
        max={50000000}
        step={1000}
        className="w-full"
      />

      <div className="flex justify-between text-sm text-black-300">
        <Typography variant="captionRegular" className="text-[10px]">
          {formatNumber(sliderValues[0])} تومان
        </Typography>
        <Typography variant="captionRegular" className="text-[10px]">
          {formatNumber(sliderValues[1])} تومان
        </Typography>
      </div>
    </div>
  );
};
